module.exports = __webpack_public_path__ + "static/img/ai_icon.de26eca4.svg";